import { useT } from '@powerportalspro/react';
import { MainGrid } from '@powerportalspro/react-fluent';
import { useMemo } from 'react';
import { CONTACTS_OF_ACTIVE_OWNERS_VIEW_ID, getContactsOfActiveOwnersView } from './AdvancedFilteringViews';

// A view that filters on a table the user may not read: Contacts of Active Owners joins each
// contact's owner, a system user, and keeps the contacts whose owner's account is enabled. The demo
// gives its visitors no access to system users, so the grid shows an error naming the table rather
// than its rows — leaving the join out would show more rows than the view means to, and the join on
// its own would match none. The fix is the developer's: give the users access to the table, or
// change the view.
//
// The Filter dialog shows the view's join, and taking it away shows the rows again. The dialog
// offers no system users to join to: its related tables are only the ones the user may read.

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.GridDemos.GridAdvancedFilteringRestrictedDemo';

export function GridAdvancedFilteringRestrictedSample() {
  const t = useT();
  const viewName = t(`${STRINGS_BASE}.view-contacts-of-active-owners`);
  const views = useMemo(() => [getContactsOfActiveOwnersView(viewName)], [viewName]);

  return (
    <MainGrid
      tableName="contact"
      minHeight="350px"
      maxHeight="350px"
      pageSize={10}
      viewIds={[CONTACTS_OF_ACTIVE_OWNERS_VIEW_ID]}
      customViewDefinitions={views}
      defaultViewId={CONTACTS_OF_ACTIVE_OWNERS_VIEW_ID}
      allowFiltering
    />
  );
}
